import client, { getResponseData } from './client';

export const getDocumentList = (appId, params) => {
    return client({
        url: '/document',
        method: 'get',
        params,
        headers: {
            ApplicationID: appId,
        },
    }).then((res) => getResponseData(res));
}

export const deleteDocument = (ids) => {
    return client.delete(`/document`, { data: { ids } });
}

export const downloadDocumentTemplate = () => {
    return client({
        url: `/document/template`,
        method: 'get',
        responseType: 'blob',
    });
}

export const uploadDocument = (data, appId) => {
    return client({
        url: '/document/upload',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data',
            'ApplicationID': appId,
        }
    });
}

export const updateDocument = (id, data) => {
    return client({
        url: `/document/${id}`,
        method: 'patch',
        data,
    });
}